import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/Home.vue";
import Documents from "../pages/Documents.vue";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import Address from "../pages/Address";
import { auth } from "../assets/js/firebase.js";
Vue.use(VueRouter);
let isAuth = (to, from, next) => {
  auth.onAuthStateChanged((user) => {
    if (user) {
      if (from.name === "login") {
        next("/admin");
      } else {
        next();
      }
    } else {
      next("/login");
    }
  });
};
let isAuthLogin = (to, from, next) => {
  auth.onAuthStateChanged((user) => {
    if (!user) return next();
    next("/");
  });
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/documents/:id",
    name: "documents",
    component: Documents,
  },
  {
    path: "/documents/:id/success",
    name: "success",
    component: Documents,
  },
  {
    path: "/admin",
    name: "admin",
    beforeEnter: isAuth,
    component: Dashboard,
  },
  {
    path: "/address",
    name: "address",
    beforeEnter: isAuth,
    component: Address,
  },
  {
    path: "/login",
    name: "login",
    beforeEnter: isAuthLogin,
    component: Login,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
